import { ProgramLifeCycleModel } from './ProgramLifeCycleModel';
import { useState } from 'react';
import { Job } from '@ssar-app/domain';
import { Icon, Tooltip } from '@chakra-ui/react';
import { AiOutlineSync } from 'react-icons/ai/index.js';

interface lifeCycleProps {
  record: Job;
}

export const ProgramLifeCycle = (props: lifeCycleProps) => {
  const { record } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip placement='left' label='Show program audit trail' hasArrow>
        <a
          href='/Show-program-life-cycle'
          onClick={(e) => {
            e.preventDefault();
            setOpen(true);
          }}
        >
          <Icon as={AiOutlineSync} sx={{ fontSize: 'md', mb: -1 }} /> Program
          Audit Trail
        </a>
      </Tooltip>
      {open && (
        <ProgramLifeCycleModel job={record} isOpen={open} setOpen={setOpen} />
      )}
    </>
  );
};
